(function () {
  if (window.__breduHomeInit) return;
  window.__breduHomeInit = true;

  function observeReveal(elements) {
    if (!elements.length) return;
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        },
        { threshold: 0, rootMargin: '0px 0px -10% 0px' }
      );
      elements.forEach(function (el) {
        obs.observe(el);
      });
    } else {
      elements.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  }

  function autoRevealSections() {
    var mainEl = document.querySelector('#MainContent');
    if (!mainEl) return;
    var sections = mainEl.querySelectorAll(':scope > .shopify-section, :scope > [id^="shopify-section-"]');
    sections.forEach(function (sec, i) {
      if (i === 0) return; // el primero (hero) se ve de inmediato, sin animar
      // Se anima el div de contenido de la sección, no el envoltorio de Shopify:
      // así el fondo (oscuro en Combos, etc.) queda pintado en el envoltorio de
      // forma fija y no desaparece junto con el contenido mientras hace fade-in,
      // lo que evita el parpadeo blanco al hacer scroll.
      var target = sec.querySelector(':scope > div') || sec;
      // Los catálogos (miles de píxeles de alto, con filtros que se deslizan de
      // lado) no se animan: una capa acelerada tan grande hacía que en el celular
      // el contenido desapareciera al deslizar los filtros.
      if (target.classList.contains('bredu-catalog')) return;
      target.classList.add('bredu-reveal');
    });
  }

  function initFilters() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('.bredu-filter-btn[data-filter]');
      if (!btn) return;
      var bar = btn.closest('.bredu-filter-bar');
      var wrapper = bar ? bar.closest('.bredu-catalog') : null;
      var grid = wrapper ? wrapper.querySelector('.bredu-catalog-grid') : null;
      if (!grid) return;

      bar.querySelectorAll('.bredu-filter-btn').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');

      var filter = btn.getAttribute('data-filter');
      var cards = grid.querySelectorAll('.bredu-product-card');
      var visibleCount = 0;

      cards.forEach(function (card) {
        var cats = (card.getAttribute('data-cat') || '').split(' ');
        var show = filter === 'all' || cats.indexOf(filter) !== -1;
        if (show) {
          visibleCount++;
          card.style.display = '';
          card.classList.remove('bredu-pop');
          void card.offsetWidth;
          card.classList.add('bredu-pop');
        } else {
          card.style.display = 'none';
        }
      });

      var countEl = wrapper.querySelector('.bredu-count');
      if (countEl) countEl.textContent = visibleCount + (visibleCount === 1 ? ' producto' : ' productos');

      var empty = wrapper.querySelector('.bredu-catalog-empty');
      if (empty) empty.classList.toggle('is-visible', visibleCount === 0);
    });
  }

  function initComboArrows() {
    document.addEventListener('click', function (ev) {
      var arrow = ev.target.closest('.bredu-combos__arrow');
      if (!arrow) return;
      var wrap = arrow.closest('.bredu-combos__rail-wrap');
      var rail = wrap ? wrap.querySelector('.bredu-combos__rail') : null;
      if (!rail) return;
      var card = rail.querySelector('.bredu-combo-card');
      var step = card ? card.getBoundingClientRect().width + 20 : 300;
      rail.scrollBy({
        left: arrow.classList.contains('bredu-combos__arrow--prev') ? -step : step,
        behavior: 'smooth',
      });
    });
  }

  function initSort() {
    document.querySelectorAll('.bredu-catalog').forEach(function (wrapper) {
      var grid = wrapper.querySelector('.bredu-catalog-grid');
      var select = wrapper.querySelector('.bredu-sort__select');
      if (!grid || !select) return;

      // Guarda el orden original (tal como viene del catálogo) para "relevancia".
      Array.from(grid.children).forEach(function (card, i) {
        card.dataset.order = i;
      });

      function applySort(value) {
        var cards = Array.from(grid.querySelectorAll('.bredu-product-card'));

        cards.sort(function (a, b) {
          if (value === 'price-asc' || value === 'price-desc') {
            var pa = parseFloat(a.getAttribute('data-price')) || 0;
            var pb = parseFloat(b.getAttribute('data-price')) || 0;
            return value === 'price-asc' ? pa - pb : pb - pa;
          }
          if (value === 'title-asc' || value === 'title-desc') {
            var ta = (a.getAttribute('data-title') || '').toLowerCase();
            var tb = (b.getAttribute('data-title') || '').toLowerCase();
            var cmp = ta.localeCompare(tb, 'es');
            return value === 'title-asc' ? cmp : -cmp;
          }
          return (parseInt(a.dataset.order, 10) || 0) - (parseInt(b.dataset.order, 10) || 0);
        });

        cards.forEach(function (card) {
          grid.appendChild(card);
        });
      }

      // Aplica el orden predeterminado del <select> (Nombre: A-Z) ya al cargar,
      // no solo cuando el usuario lo cambia.
      applySort(select.value);

      select.addEventListener('change', function () {
        applySort(select.value);
      });
    });
  }

  function initHeroReveal() {
    var selector = '[class*="__text_YLPk4p"], [class*="__button_H9gpTf"]';
    var els = document.querySelectorAll(selector);
    if (!els.length) return;
    var splash = document.getElementById('bredu-splash');
    var baseDelay = splash ? 1300 : 80;
    els.forEach(function (el, i) {
      setTimeout(function () {
        el.classList.add('bredu-hero-in');
      }, baseDelay + i * 150);
    });
  }

  function isZeroPriceText(txt) {
    return /^[^\d]*0([.,]0+)?[^\d]*$/.test(txt) && /\d/.test(txt);
  }

  function fixZeroPrices() {
    var scope = document.querySelector('#MainContent');
    if (!scope) return;
    var template = scope.getAttribute('data-template');
    if (template === 'cart') return;
    var guard = false;
    function pass() {
      if (guard) return;
      guard = true;
      scope.querySelectorAll('.price').forEach(function (el) {
        if (el.classList.contains('bredu-price-soon')) return;
        var txt = el.textContent.trim();
        if (txt && isZeroPriceText(txt)) {
          el.textContent = 'Precio próximamente';
          el.classList.add('bredu-price-soon');
        }
      });
      guard = false;
    }
    pass();
    // Solo se observan cambios continuos en la página de producto (cambia el
    // precio al cambiar de variante). En catálogo/colecciones no hace falta y
    // observar ahí de más solo añade trabajo en páginas con muchas tarjetas.
    if (template === 'product' && 'MutationObserver' in window) {
      var pending = null;
      var obs = new MutationObserver(function () {
        if (pending) clearTimeout(pending);
        pending = setTimeout(pass, 150);
      });
      obs.observe(scope, { childList: true, subtree: true, characterData: true });
    }
  }

  function updateCartBubble(count) {
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      el.removeAttribute('hidden');
      el.style.display = '';
      el.classList.toggle('visually-hidden', count === 0);
    });
  }

  function flyToCart(sourceEl, imageUrl) {
    var cartIcon = document.querySelector('.header-actions__cart-icon');
    if (!cartIcon || !sourceEl || !imageUrl || !customElements.get('fly-to-cart')) return;

    var el = document.createElement('fly-to-cart');
    el.classList.add('fly-to-cart--quick');
    el.style.setProperty('background-image', 'url(' + imageUrl + ')');
    el.style.setProperty('--start-opacity', '0');
    el.source = sourceEl;
    el.destination = cartIcon;
    document.body.appendChild(el);
  }

  function refreshCartDrawer() {
    return fetch('/?sections=cart-drawer-section', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var html = data && data['cart-drawer-section'];
        var wrapper = document.getElementById('shopify-section-cart-drawer-section');
        if (!html || !wrapper) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;

        // Si el carrito ya está abierto NO se reemplaza el <dialog> completo (lo
        // dejaba cerrado y con el scroll bloqueado, y la pantalla se veía en
        // blanco). Solo se cambia el contenido de adentro y el resto queda igual.
        var oldInner = wrapper.querySelector('.cart-drawer__inner');
        var newInner = temp.querySelector('.cart-drawer__inner');
        if (oldInner && newInner) {
          // La respuesta trae también los estilos del carrito con productos
          // (si la página cargó con el carrito vacío, la página no los tenía).
          wrapper.querySelectorAll('style[data-bredu-cart-style]').forEach(function (s) {
            s.remove();
          });
          temp.querySelectorAll('style').forEach(function (s) {
            var css = document.createElement('style');
            css.setAttribute('data-bredu-cart-style', '');
            css.textContent = s.textContent;
            wrapper.appendChild(css);
          });

          var oldFill = oldInner.querySelector('.bredu-freeship__fill');
          var wasDone = !!oldInner.querySelector('.bredu-freeship--done');
          var startWidth = oldFill ? oldFill.style.width : '0%';

          oldInner.replaceWith(newInner);

          // Anima la barra de envío gratis desde donde estaba hasta donde llegó.
          var newFill = newInner.querySelector('.bredu-freeship__fill');
          if (newFill) {
            var target = newFill.style.width;
            newFill.style.transition = 'none';
            newFill.style.width = startWidth;
            void newFill.offsetWidth;
            newFill.style.transition = '';
            newFill.style.width = target;
          }
          var nowDone = newInner.querySelector('.bredu-freeship--done');
          if (nowDone && !wasDone) nowDone.classList.add('bredu-freeship--celebrate');
          return;
        }

        var newWrapper = temp.firstElementChild;
        if (newWrapper) {
          wrapper.replaceWith(newWrapper);
        }
      })
      .catch(function () {
        /* si falla el refresco, igual se intenta abrir el carrito con lo que haya */
      });
  }

  function initQuickAdd() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('.bredu-quickadd');
      if (!btn) return;
      ev.preventDefault();
      ev.stopPropagation();
      if (btn.disabled || btn.classList.contains('is-loading')) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
      btn.classList.add('is-loading');
      btn.classList.remove('is-added', 'is-error');

      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            // /cart/add.js responde 200 con un producto agregado, o con un
            // status/description de error (p. ej. sin stock) aunque a veces
            // igual devuelva 200 — por eso se revisa el cuerpo, no solo res.ok.
            if (!res.ok || data.status || data.description || data.errors) {
              throw new Error(data.description || data.message || 'No se pudo agregar al carrito');
            }
            return data;
          });
        })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          setTimeout(function () {
            btn.classList.remove('is-added');
          }, 1800);

          flyToCart(btn, btn.getAttribute('data-image'));

          // Refresca el contenido del carrito en segundo plano (sin abrirlo),
          // así si el usuario lo abre después manualmente ya está al día.
          refreshCartDrawer();

          return fetch('/cart.js', { headers: { Accept: 'application/json' } });
        })
        .then(function (res) {
          return res && res.json ? res.json() : null;
        })
        .then(function (cart) {
          if (cart && typeof cart.item_count === 'number') {
            updateCartBubble(cart.item_count);
          }
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          setTimeout(function () {
            btn.classList.remove('is-error');
          }, 2200);
          if (window.console) {
            console.error('Bre-du quick add error:', err);
          }
        });
    });
  }

  // Rotación propia de la barra de anuncios. El script del tema dependía de
  // "hover" y de la visibilidad de la pestaña, y en celular se quedaba fijo.
  // Este avanza según el estado real del DOM cada N segundos, sin pausas.
  function initAnnouncementRotator() {
    if (window.__breduAnnRotator) return;
    window.__breduAnnRotator = true;

    setInterval(function () {
      var slides = document.querySelectorAll('.announcement-bar__slide');
      if (slides.length < 2) return;
      var current = 0;
      slides.forEach(function (slide, i) {
        if (slide.getAttribute('aria-hidden') === 'false') current = i;
      });
      var next = (current + 1) % slides.length;
      slides.forEach(function (slide, i) {
        slide.setAttribute('aria-hidden', i === next ? 'false' : 'true');
      });
    }, 5000);
  }

  function initFloatingNotice() {
    var el = document.querySelector('[data-bredu-floating-notice]');
    if (!el) return;
    var msgs = el.querySelectorAll('[data-notice-msg]');
    if (!msgs.length) return;
    var closeBtn = el.querySelector('.bredu-floating-notice__close');

    var idx = 0;
    var shown = 0;
    var maxShown = 6; // 3 mensajes, cada uno hasta 2 veces por visita
    var dismissed = false;
    var hideTimer = null;
    var loopTimer = null;

    function showNext() {
      if (dismissed || shown >= maxShown) return;
      msgs.forEach(function (m, i) {
        m.hidden = i !== idx;
      });
      idx = (idx + 1) % msgs.length;
      shown++;
      el.classList.add('is-visible');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        el.classList.remove('is-visible');
      }, 6000);
    }

    function start() {
      setTimeout(showNext, 3500);
      loopTimer = setInterval(showNext, 28000);
    }

    // Si la persona pasa el mouse por encima (para tocar el enlace de
    // WhatsApp), el aviso no se esconde hasta que lo suelte.
    el.addEventListener('mouseenter', function () {
      clearTimeout(hideTimer);
    });
    el.addEventListener('mouseleave', function () {
      if (!el.classList.contains('is-visible')) return;
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        el.classList.remove('is-visible');
      }, 2500);
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dismissed = true;
        el.classList.remove('is-visible');
        clearTimeout(hideTimer);
        clearInterval(loopTimer);
      });
    }

    // Arranca la primera vez que la persona hace scroll, no apenas carga la
    // página (así no compite con la animación de entrada del hero, etc.).
    // En escritorio el tema no hace scroll en window/body sino dentro de
    // ".page-wrapper" (ver assets/base.css), y ese evento "scroll" no burbujea;
    // por eso se escucha en fase de captura sobre document, que sí lo detecta
    // venga de donde venga (window en móvil, .page-wrapper en escritorio).
    document.addEventListener('scroll', start, { once: true, passive: true, capture: true });
  }

  function initScrollHint() {
    var mainEl = document.querySelector('#MainContent');
    if (!mainEl || mainEl.getAttribute('data-template') !== 'index') return;
    var hero = mainEl.querySelector(':scope > .shopify-section, :scope > [id^="shopify-section-"]');
    if (!hero) return;

    var hint = document.createElement('button');
    hint.type = 'button';
    hint.className = 'bredu-scroll-hint';
    hint.setAttribute('aria-label', 'Bajar para ver más');
    hint.innerHTML =
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';
    document.body.appendChild(hint);

    hint.addEventListener('click', function () {
      var next = hero.nextElementSibling;
      if (next && next.scrollIntoView) {
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    // Se basa en cuánto del hero sigue visible en pantalla (no en cuál
    // elemento hace scroll), así funciona igual en escritorio y en celular
    // sin importar si el que se mueve es la página o un contenedor interno.
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            hint.classList.toggle('is-hidden', entry.intersectionRatio < 0.6);
          });
        },
        { threshold: [0, 0.6, 1] }
      );
      obs.observe(hero);
    } else {
      hint.classList.add('is-hidden');
    }
  }

  function lockMobileHeroHeight() {
    // En iOS, cuando la barra de Safari se esconde/aparece al hacer scroll,
    // las unidades de alto de pantalla (svh/dvh) se recalculan y la imagen
    // del hero "salta" de tamaño (parece que hace zoom). Medimos el alto
    // real una sola vez y lo dejamos fijo: solo se vuelve a medir si cambia
    // el ANCHO (giro de pantalla), no cuando solo cambia el alto (barra de
    // Safari, teclado).
    var lastWidth = window.innerWidth;
    function setVh() {
      document.documentElement.style.setProperty('--bredu-vh100', window.innerHeight + 'px');
    }
    setVh();
    window.addEventListener('resize', function () {
      if (window.innerWidth !== lastWidth) {
        lastWidth = window.innerWidth;
        setVh();
      }
    });
  }

  function initMoreCards() {
    document.querySelectorAll('template.bredu-more-cards').forEach(function (tpl) {
      var grid = tpl.parentNode;
      var wrapper = grid.closest('.bredu-catalog');
      var done = false;

      function load() {
        if (done) return;
        done = true;
        grid.appendChild(tpl.content.cloneNode(true));
        tpl.remove();
        var sel = wrapper && wrapper.querySelector('.bredu-sort__select');
        if (sel) sel.dispatchEvent(new Event('change'));
        var active = wrapper && wrapper.querySelector('.bredu-filter-btn.is-active');
        if (active && active.getAttribute('data-filter') !== 'all') active.click();
      }

      if (wrapper) {
        wrapper.addEventListener(
          'pointerdown',
          function (e) {
            if (e.target.closest('.bredu-filter-bar, .bredu-sort')) load();
          },
          true
        );
      }
      if ('requestIdleCallback' in window) {
        requestIdleCallback(function () { setTimeout(load, 500); }, { timeout: 2500 });
      } else {
        setTimeout(load, 1200);
      }
    });
  }

  function initNavProgress() {
    var bar = document.createElement('div');
    bar.className = 'bredu-nav-progress';
    document.body.appendChild(bar);

    document.addEventListener('click', function (ev) {
      if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
      var a = ev.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (e) { return; }
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search) return;
      bar.classList.add('is-active');
    });

    window.addEventListener('pageshow', function () {
      bar.classList.remove('is-active');
    });
  }

  function initPrefetch() {
    var seen = {};
    function prefetch(ev) {
      var a = ev.target.closest && ev.target.closest('a[href]');
      if (!a || a.target === '_blank') return;
      var url;
      try { url = new URL(a.href, location.href); } catch (e) { return; }
      if (url.origin !== location.origin || url.hash && url.pathname === location.pathname) return;
      if (url.pathname === location.pathname && url.search === location.search) return;
      if (seen[url.href]) return;
      seen[url.href] = true;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'document';
      link.href = url.href;
      document.head.appendChild(link);
    }
    document.addEventListener('pointerover', prefetch, { passive: true });
    document.addEventListener('touchstart', prefetch, { passive: true });
  }

  function initLogoSwap() {
    var newLogo = window.BREDU_LOGO_URL;
    if (!newLogo) return;
    document.querySelectorAll('.header-logo__image').forEach(function (img) {
      img.src = newLogo;
      img.srcset = '';
      img.style.width = 'auto';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    lockMobileHeroHeight();
    initLogoSwap();
    autoRevealSections();
    observeReveal(document.querySelectorAll('.bredu-reveal'));
    initFilters();
    initComboArrows();
    initHeroReveal();
    fixZeroPrices();
    initQuickAdd();
    initSort();
    initMoreCards();
    initNavProgress();
    initPrefetch();
    initScrollHint();
    initAnnouncementRotator();
    initFloatingNotice();
  });
})();
